import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Image1 from '../assets/img/About/image1.webp';
import Image2 from '../assets/img/About/Image2.webp';
import Image3 from '../assets/img/About/Image3.webp';
import AboutBg from '../assets/img/About/AboutBg.webp';

const AboutShort = () => {
  const navigate = useNavigate();

  const handleSeeMore = () => {
    navigate('/about');
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <section
      className="relative py-16 mt-28 w-full min-h-[80vh] bg-cover bg-center"
      style={{ backgroundImage: `url(${AboutBg})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#F5F5F5] opacity-80 z-0" />

      {/* Content */}
      <div className="mx-auto flex flex-col lg:flex-row justify-center items-center w-[90%] lg:w-[70%] gap-12 relative z-10 overflow-x-hidden">
        {/* Left Side */}
        <div className="space-y-6">
          <p className="text-sm text-[#90444D] font-semibold uppercase font-playfair tracking-wider">About Our Organization</p>
          <h2 className="text-2xl md:text-3xl font-bold font-playfair text-gray-900 tracking-wider">
            We are here to support<br />
            <span className="uppercase text-[#90444D]">Children & Elders</span>
          </h2>
          <p className="leading-relaxed text-green-800">
            Christian Care for Children and Elders Association (CCCEA) is an indigenous Non-Governmental Organization
            established and registered at the Ministry of Justice in September 2006 and started its actual operation
            in November 2006.
          </p>
          {/* Button */}
          <div className="flex gap-4">
            <button
              className="border border-gray-300 px-6 text-[#90444D] py-2 rounded-md font-medium hover:bg-gray-100"
              onClick={handleSeeMore}
            >
              SEE MORE
            </button>
          </div>
          {/* Image Grid with Animations */}
          <div className="grid grid-cols-2 gap-4 mt-8">
            <motion.img
              src={Image1}
              alt="Smiling girl"
              className="shadow-custom w-full h-[250px] object-cover"
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
            />
            <motion.img
              src={Image3}
              alt="Smiling kids"
              className="shadow-custom w-full h-[250px] object-cover"
              initial={{ x: 100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
            />
          </div>
        </div>

        {/* Right Side */}
        <div className="space-y-6">
          <motion.img
            src={Image2}
            alt="Teacher with child"
            className="shadow-custom w-full h-[400px] object-cover"
            initial={{ y: 100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.7 }}
          />
          <p className="leading-relaxed text-green-800">
            We have started to incorporate income-generating programs with 15 women, and as a result, they are
            improving their income and becoming self-sufficient successfully. The main activities are:
          </p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-1">✓</span>
              <span>Children Support Program</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-600 mt-1">✓</span>
              <span>Elders Support Program</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AboutShort;
